export default __webpack_public_path__ + "static/media/1.b344e296.png";